export const ordersTabs = [
  { label: "Details", value: "details" },
  { label: "Product", value: "product_variant" },
  // { label: "Documents", value: "create_documents" },
];

export const ordersEditTabs = [
  { label: "Details", value: "details" },
  { label: "Product", value: "product" },
  { label: "Transactions", value: "transactions" },
  { label: "Documents", value: "documents" },
  { label: "Event", value: "event" },
];
